export enum HotelDistanceType {
  CITY = 'City',
  REGION = 'Region',
}
